<footer
    class="footer-area text-center bg-white border-top-radius"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.component-dark-theme]="themeService.isDark()"
>
    <p>
        {{ 'Copyright' | translate:{year: currentYear} }}
    </p>
</footer>